module.exports = __webpack_public_path__ + "img/6fb89a2.png";